import request from '@/utils/request'

/** 与后台 SoftwareUpdateLogic::check 返回一致 */
export interface SoftwareUpdateCheckData {
    ok: boolean
    message?: string
    current_version: string
    has_update: boolean
    release?: {
        version: string
        require_from_version: string
        package_url: string
        package_sha256: string
        package_size: number
        changelog: string
        update_type: number
    } | null
}

/** 检查是否有下一版本 */
export function softwareUpdateCheck() {
    return request.get<SoftwareUpdateCheckData>({
        url: '/update.SoftwareUpdate/check'
    })
}

/** 执行 php think version_updating（耗时长） */
export function softwareUpdateApply() {
    return request.post(
        {
            url: '/update.SoftwareUpdate/apply',
            timeout: 600 * 1000
        },
        { isOpenRetry: false }
    )
}
